import React from 'react';
import { SvgIconCacheContextModel } from './model';

export const SvgIconCacheContext = React.createContext<SvgIconCacheContextModel>({ store: {} });
